
import { Component, Vue } from 'vue-property-decorator';
import moment from 'moment';
import { VMoney } from 'v-money';

@Component({
  components: {},
  computed: {
    years() {
      let years: any = [];
      for (let i: number = new Date().getFullYear(); i >= 2000; i--) {
        years.push(i);
      }
      return years;
    },
  },
  filters: {},
  watch: {},
  directives: { money: VMoney },
})
export default class NewRequestAutomovil extends Vue {
  title: string = 'Crear Solicitud';
  isLoading: boolean = false;
  coinsurance_companies: any = [];
  data: any = {
    certificate_number: {
      value: '',
      label: 'Número del Certificado',
    },
    brand: {
      value: '',
      label: 'Marca',
    },
    licenseplate: {
      value: '',
      label: 'Placa',
    },
    insured_fullname: {
      value: '',
      label: 'Nombre de los Asegurados',
    },
    model: {
      value: '',
      label: 'Modelo',
    },
    vehicle_type: {
      value: '',
      label: 'Tipo de Vehículo',
    },
    year: {
      value: '0',
      label: 'Año',
    },

    coinsurance_participation: {
      value: '',
      label: 'Participación en Coaseguro',
      error: false,
      errorMessage: '',
    },
    excluded_from_contract: {
      value: '',
      label: 'Excluido del Contrato',
      error: false,
      errorMessage: '',
    },
    special_aceptation: {
      value: '',
      label: 'Aceptación Especial',
      error: false,
      errorMessage: '',
    },
    total_sum_secured: {
      value: '',
      label: 'Suma Total Asegurada',
      error: false,
      errorMessage: '',
    },
    aon_sum: {
      value: '',
      label: 'Suma cedida AON CAP',
      error: false,
      errorMessage: '',
    },
    facultative_sum: {
      value: '',
      label: 'Suma cedida a Facultativos/Otros',
      error: false,
      errorMessage: '',
    },
    retained_sum: {
      value: '',
      label: 'Suma retenida + Cesión a contrato automático',
      error: false,
      errorMessage: '',
    },
    original_tax: {
      value: '0,00',
      label: 'Tasa Original',
      error: false,
      errorMessage: '',
    },
    original_gross_bonus: {
      value: '',
      label: 'Prima Bruta Original Anual',
      error: false,
      errorMessage: '',
    },
    original_gross_bonus_parcial: {
      value: '0,00',
      label: 'Prima Bruta Original por el periodo',
      error: false,
      errorMessage: '',
    },
    original_gross_aon: {
      value: '0,00',
      label: 'Prima Bruta Cedida a AON',
      error: false,
      errorMessage: '',
    },

    country: {
      value: '',
      label: 'País',
    },
    province: {
      value: '',
      label: 'Estado / Provincia',
    },
    city: {
      value: '',
      label: 'Ciudad',
    },
    address: {
      value: '',
      label: 'Dirección',
    },
    zipcode: {
      value: '',
      label: 'Código postal',
    },
    notes: {
      label: "Observaciones",
      value: ""
    },
    money: {
      decimal: ',',
      thousands: '.',
      prefix: '',
      suffix: '',
      precision: 2,
      masked: true,
    },
    coordinate_lat: 0,
    coordinate_lng: 0,
  };
  subscriptor: any = '';
  bien: any = null;
  conditions: any = {};
  currency: any = {};
  controlzones: any = {};
  company: any = '';
  branch: any = null;
  countries: any = null;
  companies: any = null;

  autocomplete: any = null;

  moneyFields: string[] = [
    'aon_sum',
    'facultative_sum',
    'original_gross_aon',
    'original_gross_bonus',
    'original_gross_bonus_parcial',
    'original_tax',
    'retained_sum',
    'total_sum_secured',
  ];

  parseMoneyToNumber(value: any): number {
    if (typeof value === 'number') return value;
    return parseFloat(String(value).replace(/\./g, '').replace(',', '.'));
  }

  parseMoneyFields(obj: any) {
    this.moneyFields.forEach((key) => {
      if (obj[key]) obj[key] = this.parseMoneyToNumber(obj[key]);
    });
  }

  clearFieldErrors() {
    this.moneyFields.forEach((key) => {
      if (this.data[key]) {
        this.data[key].error = false;
        this.data[key].errorMessage = '';
      }
    });
  }

  setFieldErrors(errors: Array<{ field: string; message: string }>) {
    errors.forEach((err) => {
      if (err.field && this.data[err.field]) {
        this.data[err.field].error = true;
        this.data[err.field].errorMessage = err.message || 'Campo inválido';
      }
    });
  }

  async onDataChange(calculate_tax_first) {
    this.clearFieldErrors();
    let requestData: any = this.getBien();

    let validateData: any = await this.validate(requestData);

    if (!validateData) return;

    if (validateData.status === false && validateData.data && Array.isArray(validateData.data.errors)) {
      this.setFieldErrors(validateData.data.errors);
      return;
    }

    const moneyResponseFields = ['original_gross_bonus', 'original_gross_bonus_parcial', 'original_gross_aon'];
    Object.keys(validateData.data).forEach((key) => {
      if (this.data[key]) {
        if (moneyResponseFields.includes(key)) {
          const num = parseFloat(String(validateData.data[key]));
          if (!isNaN(num)) {
            const precision = this.data.money.precision || 2;
            const parts = num.toFixed(precision).split('.');
            const intFormatted = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
            this.data[key].value = intFormatted + ',' + parts[1];
          } else {
            this.data[key].value = validateData.data[key];
          }
        } else {
          this.data[key].value = validateData.data[key];
        }
      }
    });

    if (validateData.error) {
      (this.$root as any).notify(validateData.error, 'warn');
    }
  }

  async mounted() {
    this.subscriptor = this.$store.state.user.fullname;
    this.loadControlZones();
    this.loadCompany();
    this.loadCompanies();
    this.loadConditions();
    this.loadCurrencies();
    this.loadBranches();
    this.loadCountries();
    this.loadFilledData();
    this.initGoogleAutocomplete();
    this.fillInAddress();
  }

  initGoogleAutocomplete() {
    var options = {
      types: ['address'],
      componentRestrictions: { country: ['ar', 'cl', 'uy', 'py'] },
    };

    this.autocomplete = new google.maps.places.Autocomplete(
      this.$refs.autocomplete as HTMLInputElement,
      options
    );
    this.autocomplete.setFields([
      'address_components',
      'geometry',
      'icon',
      'name',
    ]);
    this.autocomplete.addListener('place_changed', this.fillInAddress);
  }

  fillInAddress() {
    var place = this.autocomplete.getPlace();

    var map = new google.maps.Map(document.getElementById('map'), {
      mapTypeId: 'roadmap',
      center: { lat: -34.6177, lng: -58.3621 },
      zoom: 3,
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: true,
      scaleControl: true,
      styles: [
        {
          featureType: 'transit',
          stylers: [
            {
              visibility: 'off'
            }
          ]
        },
        {
          featureType: 'poi',
          stylers: [{ visibility: 'off' }]
        }
      ],
    });
    if (!place) return;
    var marker = new google.maps.Marker({
      map: map,
      anchorPoint: new google.maps.Point(0, -29),
    });

    if (place.geometry.viewport) {
      map.fitBounds(place.geometry.viewport);
    } else {
      map.setCenter(place.geometry.location);
      map.setZoom(17);
    }
    marker.setPosition(place.geometry.location);
    marker.setVisible(true);

    this.data.address.value =
      place.address_components.find((e) => e.types[0] === 'route').long_name +
      ' ' +
      (place.address_components.find((e) => e.types[0] === 'street_number')
        ? place.address_components.find((e) => e.types[0] === 'street_number')
            .long_name
        : '');
    this.data.country.value = place.address_components.find(
      (e) => e.types[0] === 'country'
    )
      ? place.address_components.find((e) => e.types[0] === 'country').long_name
      : '';
    this.data.province.value = place.address_components.find(
      (e) => e.types[0] === 'administrative_area_level_1'
    )
      ? place.address_components.find(
          (e) => e.types[0] === 'administrative_area_level_1'
        ).long_name
      : '';
    this.data.city.value = place.address_components.find(
      (e) => e.types[0] === 'administrative_area_level_2'
    )
      ? place.address_components.find(
          (e) => e.types[0] === 'administrative_area_level_2'
        ).long_name
      : '';
    this.data.zipcode.value = place.address_components.find(
      (e) => e.types[0] === 'postal_code'
    )
      ? place.address_components.find((e) => e.types[0] === 'postal_code')
          .long_name
      : '';
    this.data.coordinate_lat = place.geometry.location.lat();
    this.data.coordinate_lng = place.geometry.location.lng();
  }

  loadFilledData() {
    if (this.$store.state.newRequest.conditions) {
      Object.entries(this.$store.state.newRequest.conditions).forEach(
        ([key, value]) => (this.data[key] = { ...this.data[key], value })
      );
    }
  }

  async loadCompanies() {
    let companies: any = [];
    let today = moment();
    const response: any = await (this.$root as any)._post('companies/all', {
      skipRole: true,
    });
    response.data.forEach((c) => {
      if (this.$store.state.companyId === c.id) return;
      if (this.$store.state.user.companies[0].countryId !== c.countryId) return;
      if (
        moment(c.date_request_from).isBefore(today) &&
        moment(c.date_request_to).isAfter(today)
      ) {
        companies.push(c);
      }
    });
    this.companies = companies;
  }

  async loadConditions() {
    this.conditions = { ...this.$store.state.newRequest.conditions };
  }

  async loadControlZones() {
    const user: any = await (this
      .$root as any)._post(`subscriptors/one/${this.$store.state.user.id}`, {
      models: 'companies',
    });
    const company: any = user.data[0].companies[0];
    const response: any = await (this.$root as any)._post('controlzones/all', {
      countryId: company.countryId,
    });
    this.controlzones = response.data;
  }

  async loadCompany() {
    this.company = this.$store.state.user.companies.filter(
      (c) => c.id === this.$store.state.companyId
    )[0].name;
  }

  async loadBranches() {
    const response: any = await (this.$root as any)._get(
      `branches/one/${this.$store.state.newRequest.branch}`
    );
    this.branch = response.data[0].title;
  }

  async loadCurrencies() {
    const response: any = await (this.$root as any)._get('currencies/all');
    this.currency = response.data.filter(
      (c) => c.id === this.conditions.currency_id
    )[0].title;
  }

  async loadCountries() {
    const response: any = await (this.$root as any)._get('countries/all');
    this.countries = response.data;
  }

  prevStep() {
    this.$router.push('/requests/new-request/conditions');
  }

  cancelNewRequest() {
    this.$store.commit('clearNewRequest');
  }

  getBien() {
    return {
      rdCountry: this.data.country.value,
      branchId: this.$store.state.newRequest.branch,
      insured_fullname: this.data.insured_fullname.value,
      city: this.data.city.value,
      province: this.data.province.value,
      address: this.data.address.value,
      certificate_number: this.data.certificate_number.value,
      brand: this.data.brand.value,

      licenseplate: this.data.licenseplate.value,
      vehicle_type: this.data.vehicle_type.value,
      model: this.data.model.value,
      year: this.data.year.value,

      coordinate_lat: this.data.coordinate_lat,
      coordinate_lng: this.data.coordinate_lng,

      total_sum_secured: this.data.total_sum_secured.value,
      coinsurance_participation: this.data.coinsurance_participation.value !== '' ? parseInt(this.data.coinsurance_participation.value) : '',
      excluded_from_contract: this.data.excluded_from_contract.value !== '' ? parseInt(this.data.excluded_from_contract.value) : '',
      aon_sum: this.data.aon_sum.value,
      special_aceptation: this.data.special_aceptation.value !== '' ? parseInt(this.data.special_aceptation.value) : '',
      facultative_sum: this.data.facultative_sum.value,
      retained_sum: this.data.retained_sum.value,
      original_tax: this.data.original_tax.value,
      original_gross_bonus: this.data.original_gross_bonus.value,
      original_gross_bonus_parcial: this.data.original_gross_bonus_parcial.value,
      original_gross_aon: this.data.original_gross_aon.value,
      notes: this.data.notes.value,

      companyId: this.$store.state.companyId,
      policy_number: this.conditions.policy_number,
      assignmentValidityAonFrom: this.conditions.assignmentValidityAonFrom,
      assignmentValidityAonTo: this.conditions.assignmentValidityAonTo,
      validity_from: this.conditions.validity_from,
      validity_to: this.conditions.validity_to,
      assignment_percent_aon: this.conditions.assignment_percent_aon,
      controlZoneId: this.conditions.controlZoneId,
      currencyId: this.conditions.currency_id,
      modifyType: 0,
    };
  }

  async validate(values: any) {
    let requestToValidate: any = {
      branchId: this.$store.state.newRequest.branch,
      companyId: this.$store.state.companyId,
      currencyId: this.conditions.currency_id,
      special_aceptation: this.data.special_aceptation.value !== '' ? parseInt(this.data.special_aceptation.value) : '',
      facultative_sum: values.facultative_sum,
      original_gross_bonus: values.original_gross_bonus,
      original_gross_bonus_parcial: values.original_gross_bonus_parcial,
      original_tax: values.original_tax,
      aon_sum: values.aon_sum,
      retained_sum: values.retained_sum,
      total_sum_secured: values.total_sum_secured,
      yeardays: moment(this.conditions.validity_to, 'YYYY/MM/DD').diff(
        moment(this.conditions.validity_from, 'YYYY/MM/DD'),
        'days'
      ),
      period: moment(
        this.conditions.assignmentValidityAonTo,
        'YYYY/MM/DD'
      ).diff(
        moment(this.conditions.assignmentValidityAonFrom, 'YYYY/MM/DD'),
        'days'
      ),
    };

    this.parseMoneyFields(requestToValidate);

    try {
      return await (this.$root as any)._post('requests/validate', requestToValidate);
    } catch (e: any) {
      if (e && e.data && Array.isArray(e.data.errors)) {
        return e;
      }
      (this.$root as any).notify(e, 'error');
      return false;
    }
  }

  async agregarBien() {
    if (!this.bien) {
      let hasError = false;

      if (this.data.special_aceptation.value === '') {
        this.data.special_aceptation.error = true;
        this.data.special_aceptation.errorMessage = 'Este campo es requerido';
        hasError = true;
      } else {
        this.data.special_aceptation.error = false;
        this.data.special_aceptation.errorMessage = '';
      }

      if (this.data.coinsurance_participation.value === '') {
        this.data.coinsurance_participation.error = true;
        this.data.coinsurance_participation.errorMessage = 'Este campo es requerido';
        hasError = true;
      } else {
        this.data.coinsurance_participation.error = false;
        this.data.coinsurance_participation.errorMessage = '';
      }

      if (this.data.excluded_from_contract.value === '') {
        this.data.excluded_from_contract.error = true;
        this.data.excluded_from_contract.errorMessage = 'Este campo es requerido';
        hasError = true;
      } else {
        this.data.excluded_from_contract.error = false;
        this.data.excluded_from_contract.errorMessage = '';
      }

      if (hasError) return;

      let bien: any = this.getBien();
      let response: any = await this.validate(bien);
      if (response && response.data) {
        const moneyResponseFields = ['original_gross_bonus', 'original_gross_bonus_parcial', 'original_gross_aon'];
        Object.keys(response.data).forEach((key) => {
          if (this.data[key]) {
            if (moneyResponseFields.includes(key)) {
              const num = parseFloat(String(response.data[key]));
              if (!isNaN(num)) {
                const precision = this.data.money.precision || 2;
                const parts = num.toFixed(precision).split('.');
                const intFormatted = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
                this.data[key].value = intFormatted + ',' + parts[1];
              }
            } else {
              this.data[key].value = response.data[key];
            }
          }
        });
        this.bien = { ...bien, ...response.data };
      }
    }
  }

  eliminarBien() {
    this.bien = null;
  }

  async nextStep() {
    if (this.bien && !this.isLoading) {
      this.isLoading = true;
      this.$modal.show("loading");

      try {
        let data = this.bien;
        this.parseMoneyFields(data);

        data.original_gross_bonus_anual = data.original_gross_bonus;
        data.original_gross_bonus = data.original_gross_bonus_parcial;
        data.countryId = this.$store.state.user.companies[0].countryId;
        data.controlZoneId =
          data.controlZoneId == 'NULL' ? null : data.controlZoneId;
        data.coinsurance_companies = this.coinsurance_companies.join(',');
        data.assignment_percent_aon = data.assignment_percent_aon
          .replace(/%/g, '')
          .replace(/\./g, '')
          .replace(/,/g, '.');

        const res: any = await (this.$root as any)._post('requests', data);

        this.$modal.hide("loading");
        (this.$root as any).notify('Solicitud creada con éxito', 'success');
        setTimeout(() => this.$store.commit('clearNewRequest'), 3000);
      } catch (e) {
        this.$modal.hide("loading");
        (this.$root as any).notify(e, 'error');
      }

      this.isLoading = false;
    }
  }
}
